(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[788],{

/***/ 69953:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-instructions",
      function () {
        return __webpack_require__(54187);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ service_instructions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./reusable/ContentWithForm.tsx + 4 modules
var ContentWithForm = __webpack_require__(88551);
// EXTERNAL MODULE: ./api/delek.ts
var delek = __webpack_require__(55417);
// EXTERNAL MODULE: ./typings/contentPage.ts
var contentPage = __webpack_require__(96860);
;// CONCATENATED MODULE: ./components/pages/ServiceInstructionsPage.tsx





var ServiceInstructionsPage = function() {
    var buttons = [
        {
            value: "licenseNumber",
            name: "מס׳ לוחית רישוי"
        },
        {
            value: "chassis",
            name: "מס׳ שלדה"
        }, 
    ];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var headerText = !isDesktop ? [
        "הוראות שירות הינה פניה יזומה של יצרן הרכב אל בעל הרכב שמטרתה ביצוע של בדיקה ו/או פעולה מונעת\n    ו/או תיקון ברכב", 
    ] : [
        "הוראות שירות הינה פניה יזומה של יצרן הרכב אל בעל הרכב שמטרתה ביצוע של בדיקה ו/או פעולה מונעת",
        "ו/או תיקון ברכב", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWithForm/* default */.Z, {
        title: "בדיקת הוראת שירות",
        headerText: headerText,
        background: [
            "/img/Serviceinstructionsmobile.jpg",
            "/img/Serviceinstructions.jpg", 
        ],
        subtitle: "כדי לבדוק אם קיימת בקשה להוראת שירות למאזדה שלך, יש להקליד כאן את מספר לוחית הרישוי או השלדה",
        buttons: buttons,
        inputLabel: "מספר לוחית רישוי\n      (משמאל לימין)",
        inputType: "text",
        submitText: "לבדיקה",
        bottomTitle: "שירות הלקוחות שלנו זמין בשבילך לכל עניין:",
        phoneNumber: "*2880",
        getData: delek/* getServiceInstructions */.JU,
        type: contentPage/* ContentItemType.RECALL */.o.RECALL,
        page: "instructions",
        breadCrumbName: "ServiceInstructions"
    });
};
/* harmony default export */ var pages_ServiceInstructionsPage = (ServiceInstructionsPage);

;// CONCATENATED MODULE: ./src/pages/service-instructions.tsx



var ServiceInstructions = function(param) {
    var seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_ServiceInstructionsPage, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var service_instructions = (ServiceInstructions);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4245,2669,6808,6104,8551,9774,2888,179], function() { return __webpack_exec__(69953); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);